import { ReactNode } from "react";

import { Backdrop } from "~/ui/base/Backdrop.tsx";
import { Layer } from "~/ui/provider/StackedLayerProvider.tsx";

export const WebDraggableSheet = ({
  children,
  close,
  descriptionId,
  titleId,
  visible,
}: Omit<Parameters<Layer>[0], "context"> & {
  children: ReactNode;
}) => {
  return (
    <Backdrop
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <div
        className={`pointer-events-none fixed inset-0 z-40 flex items-center justify-center p-3 sm:p-4 ${
          visible ? "animate-stacked-layer-from" : "animate-stacked-layer-to"
        }`}
      >
        <div className="pointer-events-auto max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-5 shadow-2xl sm:rounded-3xl sm:p-6 dark:bg-zinc-900">
          {children}
        </div>
      </div>
    </Backdrop>
  );
};

export const createWebDraggableSheet = <Context = unknown,>(
  Content: (props: Parameters<Layer<Context>>[0]) => ReactNode,
): Layer<Context> => {
  const Component = (({ close, context, descriptionId, titleId, visible }) => (
    <WebDraggableSheet
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <Content
        close={close}
        context={context}
        descriptionId={descriptionId}
        titleId={titleId}
        visible={visible}
      />
    </WebDraggableSheet>
  )) satisfies Layer<Context>;
  return Component;
};
